import React, { useEffect, useState } from "react";
import {
    Box,
    Flex,
    SimpleGrid,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";

// Custom components
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import Icon from "components/icons/Icon";

// Icons
import { MdBarChart, MdOutlineFitnessCenter, MdPeople, MdTrendingUp } from "react-icons/md";
import { exerciseService } from "services/exerciseService";

interface ExerciseStatsData {
    totalExercises: number;
    publicExercises: number;
    strengthExercises: number;
    cardioExercises: number;
}

export default function ExerciseStats() {
    // Chakra Color Mode
    const brandColor = useColorModeValue("brand.500", "white");
    const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

    const [stats, setStats] = useState<ExerciseStatsData>({
        totalExercises: 0,
        publicExercises: 0,
        strengthExercises: 0,
        cardioExercises: 0,
    });

    useEffect(() => {
        loadStats();
    }, []);

    const loadStats = async () => {
        try {
            // Get exercises data to calculate stats
            const response = await exerciseService.getExercises({
                limit: 1000,
                page: 1
            });
            const exercises = response.exercises || [];

            const calculatedStats = {
                totalExercises: exercises.length,
                publicExercises: exercises.filter((e: any) => e.isPublic).length,
                strengthExercises: exercises.filter((e: any) => e.category === "strength").length,
                cardioExercises: exercises.filter((e: any) => e.category === "cardio").length,
            };

            setStats(calculatedStats);
        } catch (error) {
            console.error("Failed to load exercise stats:", error);
        }
    };

    return (
        <SimpleGrid
            columns={{ base: 1, md: 2, lg: 4 }}
            gap="20px"
        >
            <MiniStatistics
                startContent={
                    <IconBox
                        width="56px"
                        height="56px"
                        bgColor={boxBg}
                        icon={
                            <Icon as={MdOutlineFitnessCenter} width="32px" height="32px" />
                        }
                    />
                }
                name="Total Exercises"
                value={stats.totalExercises.toString()}
            />
            <MiniStatistics
                startContent={
                    <IconBox
                        width="56px"
                        height="56px"
                        bgColor={boxBg}
                        icon={<Icon as={MdPeople} width="32px" height="32px" />}
                    />
                }
                name="Public Exercises"
                value={stats.publicExercises.toString()}
            />
            <MiniStatistics
                startContent={
                    <IconBox
                        width="56px"
                        height="56px"
                        bgColor={boxBg}
                        icon={<Icon as={MdTrendingUp} width="32px" height="32px" />}
                    />
                }
                name="Strength Exercises"
                value={stats.strengthExercises.toString()}
            />
            <MiniStatistics
                startContent={
                    <IconBox
                        width="56px"
                        height="56px"
                        bgColor={boxBg}
                        icon={<Icon as={MdBarChart} width="32px" height="32px" />}
                    />
                }
                name="Cardio Exercises"
                value={stats.cardioExercises.toString()}
            />
        </SimpleGrid>
    );
}
